import { css } from "@emotion/react"
import { AudioPlayerControls } from "source/shared/components/AudioPlayerControls"
import { ExpandableDescription } from "../ExpandableDescription"
import type { Episode } from "../types"
import EpisodeArtworkFallback from "./EpisodeArtworkFallback"

export default function SelectedEpisode({
  episode,
  onPlay,
  onPause,
}: {
  episode: Episode
  onPlay: () => void
  onPause: () => void
}) {
  return (
    <>
      <div css={styles.wrapper}>
        {episode.artwork ? (
          <img src={episode.artwork} alt={episode.title} css={styles.artwork} />
        ) : (
          <EpisodeArtworkFallback size={160} borderRadius={6} />
        )}
        <div css={styles.content}>
          <h3 css={styles.title}>{episode.title}</h3>
          {episode.description && (
            <ExpandableDescription
              text={episode.description}
              textStyle={styles.description}
              characterLimit={68}
              isHtml
            />
          )}
        </div>
      </div>

      <AudioPlayerControls
        key={episode.audioUrl}
        src={episode.audioUrl}
        showSkipButtons={true}
        variant="stacked"
        onPlay={onPlay}
        onPause={onPause}
        onEnded={onPause}
      />
    </>
  )
}

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
  `,
  artwork: css`
    width: 160px;
    height: 160px;
    border-radius: 6px;
    object-fit: cover;
    align-self: center;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,
  title: css`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--d-text-color-headline);
  `,
  description: css`
    font-size: 14px;
  `,
}
